module.exports = __webpack_public_path__ + "static/media/times-square.2d8cae4c.svg";